export default __webpack_public_path__ + "static/media/Footwear.60e3a008.png";